// extracted by mini-css-extract-plugin
module.exports = {"couplet-main-wrapper":"couplet-m__couplet-main-wrapper__213Ih","couplet-wrapper":"couplet-m__couplet-wrapper__1CRC8","summary":"couplet-m__summary__fPcmI"};